import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Input, Typography, Tooltip } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectOptimizerParamsInput: React.FC<Props> = ({ store }) => {
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <Typography.Title level={5} style={{ margin: 0 }}>
                    Optimizer Params
                </Typography.Title>
                <Tooltip title="View DSPy optimizer documentation">
                    <Typography.Link
                        href="https://dspy.ai/learn/optimization/overview/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '14px', display: 'flex', alignItems: 'center' }}
                    >
                        <LinkOutlined style={{ fontSize: '12px' }} />
                    </Typography.Link>
                </Tooltip>
            </div>

            <Form.Item
                name={trainingProjectFormFields.optimizerParams}
                initialValue={store.editableTrainingProject ? store.editableTrainingProject.optimizerParams : undefined}
            >
                <Input.TextArea placeholder='{ "max_bootstrapped_demos": 4, "max_labeled_demos": 16 }' rows={8} />
            </Form.Item>
        </>
    );
};

export default observer(TrainingProjectOptimizerParamsInput);
